import { createCodespotApiService } from '@/api/toya/createCodespotApiService'
import { createStreamIQApiService } from '@/api/streemiq/createStreamIQApiService'
import { isStreamIQ, isToya } from '@/shared/lib'

export const getApiService = () => {
    if (isToya()) {
        return createCodespotApiService()
    }
    if (isStreamIQ()) {
        return createStreamIQApiService()
    }
    throw new Error('Unknown API type')
}
